/** XEP-0308 Edit, send side. The read side is `parse.ts` beside it. */
import xml, { type Element as XmlEl } from "@xmpp/xml"
import type { Jid } from "../../../jid"
import { NS_MESSAGE_CORRECT } from "../../../constants"
import { buildBody, buildMessage } from "../build"

/**
 * `targetId` goes in `<replace>`; `bounceId` is the Edit's own stanza id, which
 * a refusal echoes back. No `<edited>` marker: the server stamps its own.
 */
export const buildEditMessage = (
  peer: Jid,
  targetId: string,
  body: string,
  bounceId: string
): XmlEl =>
  buildMessage(
    bounceId,
    peer,
    buildBody(body),
    xml("replace", { xmlns: NS_MESSAGE_CORRECT, id: targetId })
  )
